
const NotExist = () => {

    return(
        <>dey</>
    )
};

export default NotExist;